import { render, staticRenderFns } from "./DetailChartOfAccount.vue?vue&type=template&id=2269ed0d"
import script from "./DetailChartOfAccount.vue?vue&type=script&lang=js"
export * from "./DetailChartOfAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports